import DiallingCodesSelector from './DiallingCodesSelector';

export default DiallingCodesSelector;
